export const FIRST_NAME_MAX_LENGTH = 70;
export const MIDDLE_NAME_MAX_LENGTH = 40;
export const LAST_NAME_MAX_LENGTH = 100;

export const firstNameMaxMessage = `First name must be less than ${FIRST_NAME_MAX_LENGTH} characters`;
export const middleNameMaxMessage = `Middle name must be less than ${MIDDLE_NAME_MAX_LENGTH} characters`;
export const lastNameMaxMessage = `Last name must be less than ${LAST_NAME_MAX_LENGTH} characters`;